/** Published pricing — mirrors backend/models.py SUBSCRIPTION_PLANS (the Billing page
 *  also fetches /api/billing/plans and prefers the server's numbers). Monthly ₹, annual ₹,
 *  limits (-1 = unlimited) and the file-storage allowance per workspace. */
export const PLAN_PRICING = [
  { key: "starter",    name: "Starter", price: 2999,  annual: 29990,  projects: 5,  users: 10, storage_gb: 5,   highlight: false },
  { key: "growth",     name: "Growth",  price: 6999,  annual: 69990,  projects: 20, users: 30, storage_gb: 25,  highlight: true  },
  { key: "enterprise", name: "Scale",   price: 12999, annual: 129990, projects: -1, users: -1, storage_gb: 100, highlight: false },
];

export const LIFETIME_PLAN = { key: "lifetime", name: "Lifetime", price: 1000000, projects: -1, users: -1, storage_gb: -1, contact_sales: true };
export const SALES_EMAIL = "akshay@sunbizcon.com";

export const fmtINR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
export const limitLabel = (n, noun) => n === -1 ? `Unlimited ${noun}` : `${n} ${noun}`;
export const fmtBytes = (b) => {
  const n = Number(b) || 0;
  if (n >= 1024 ** 3) return `${(n / 1024 ** 3).toFixed(n >= 10 * 1024 ** 3 ? 0 : 1)} GB`;
  if (n >= 1024 ** 2) return `${(n / 1024 ** 2).toFixed(0)} MB`;
  return `${Math.round(n / 1024)} KB`;
};
